import { action } from 'easy-peasy';
import { IActionSetTemplatesByTypeId } from '../types';

const setTemplatesByTypeId: IActionSetTemplatesByTypeId = action((state, { typeId, items }) => {
  state.itemsByTypeId[typeId] = items;
});

export default setTemplatesByTypeId;
